import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const Portfolio = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "0",
        height: "0",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14 2l3 1v3h4l1 1.06V21l-1 1H3l-1-1V7l1-1h4V3l3-1h4zm6 11.8l-6 2.4V18h-4v-1.8l-6-2.4V20h16v-6.2zM20 8H4v3.65l.88.35L10 14.049V13h4v1.049L19.12 12l.88-.35V8zm-6.32-4h-3.36L9 4.44V6h6V4.44L13.68 4z"
    })));
};
Portfolio.displayName = 'PortfolioIcon';
export default Portfolio;
